import { functions } from './appwriteClient';
import { ExecutionMethod } from "appwrite";

const MAILER_FUNCTION_ID = '68711e4a00390d239928';

// Calls the Appwrite Function directly, passing arguments as JSON payload
export async function sendMail({
  to,
  html,
  subject
}: {
  to: string;
  html: string;
  subject: string
}) {

if (!to) throw new Error('Recipient email is required');
if (!html) throw new Error('HTML content is required');

    const promise = functions.createExecution(
            MAILER_FUNCTION_ID,  // functionId
            JSON.stringify({to: to, html: html, subject: subject}),  // body (optional)
            true,  // async (optional)
            '/',  // path (optional)
            ExecutionMethod.GET,  // method (optional)
            {} // headers (optional)
        );

    promise.then(function (response) {
        console.log(response); // Success
    }, function (error) {
        console.log(error); // Failure
    });
} 